import React, { useEffect, useLayoutEffect, useState } from "react";
import { ResponsiveModal, LoadContainer } from "./style";
import MainButton from "../MainButton";
import CurrencyFormat from "../../utils/currencyFormat";
import { Close } from "./Close";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import Discount from "../Discount";
import Spinner from "../../components/Spinner";
import useView from "../../hooks/useView";
import { breakPoints } from "../../theme/theme";
import RelatedProducts from "../RelatedProducts";
import CornerRibbon from "react-corner-ribbon";
import useRouter from "../../hooks/useRouter";
import { calculatePriceWithTax, findNameRef } from "../../utils/formatData";
import { language } from "../../utils/language";
import { locateImage } from "../../helpers/imageExists";
import { captureCartReturnPath } from "../../utils/cartReturnPath";

const MainModal = (props: any) => {
	const { width } = useView();
	const [urlProduct, setUrlProduct] = useState("");
	const [loading, setLoading] = useState(true);
	const {
		product,
		setShowModal,
		showModal,
		color,
		quantity,
		refSelect,
		refIdLocal,
	} = props;
	const productState: any = useSelector((state: RootState) => state.product);
	const shoppingCart: any = useSelector(
		(state: RootState) => state.shoppingCart
	);
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	const isMobile = width < breakPoints.md;
	const { history } = useRouter();

	const handleShowModal = () => {
		if (showModal) {
			setShowModal(false);
		} else {
			setShowModal(true);
		}
	};

	const pushToSummary = () => {
		history.push(
			`/vende/${homeState.catalogueUrlName}/carrito/${shoppingCart.id}`,
			{ from: captureCartReturnPath() }
		);
	};

	useEffect(() => {
		setLoading(shoppingCart.loading);
	}, [shoppingCart.loading]);

	useLayoutEffect(() => {
		let originalStyle: string = "";
		if (isMobile) {
			originalStyle = window.getComputedStyle(document.body).overflow;
			if (showModal) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = originalStyle;
			}
		}

		return () => {
			if (originalStyle !== "") document.body.style.overflow = originalStyle;
		};
	}, [showModal, width]);

	const findAmountProduct = (field: string | null = "amount") => {
		if (product.references && product.references.length > 0) {
			const reference = product.references.find(
				(item: any) => item.id === refIdLocal
			);
			if (field !== null && reference) {
				return reference?.[field];
			}
			return reference;
		}
		return field !== null ? product[field] : product;
	};

	const validateImgURL = (url: string) => {
		let imgURL;

		if (Array.isArray(url)) {
			imgURL = url[0];
		} else {
			imgURL = url;
		}

		if (!imgURL || imgURL.includes("null")) {
			return productState.productInfo.img[0];
		}
		return imgURL;
	};

	const currentImgUrl = validateImgURL(findAmountProduct("img"));

	useEffect(() => {
		let isMounted = true;
		if (currentImgUrl) {
			locateImage(currentImgUrl).then((url) => {
				if (isMounted) setUrlProduct(url);
			});
		}
		return () => {
			isMounted = false;
		};
	}, [currentImgUrl]);
	

	return (
		<>
			<ResponsiveModal {...props} loading={loading}>
				<section className="modal-main">
					{loading ? (
						<LoadContainer>
							<Spinner color={color} />
						</LoadContainer>
					) : (
						<>
							<div className="container">
								<div className="product-data-title show-mobile">
									<div>{language[homeState.default_language]["addProductSuccess"]}</div>
									<div>
										<Close onClick={handleShowModal} color={color}>
											{" "}
										</Close>
									</div>
								</div>
								<div className="modal-image-container">
									<img src={urlProduct} className="modal-image" alt="producto" />
									{findAmountProduct("discountRate") > 0 && (
										<CornerRibbon
											backgroundColor="#ff0000"
											fontColor="#f0f0f0"
											containerStyle={{}}
										>
											<span
												style={{
													fontFamily: "Roboto",
													fontWeight: 700,
													fontSize: "1.4em",
												}}
											>
												{" " + findAmountProduct("discountRate")}%off
											</span>
										</CornerRibbon>
									)}
								</div>

								<div className="container__product-info">
									<div className="product-data-title">
										<div>{language[homeState.default_language]["addProductSuccess"]}</div>
										<div>
											<Close onClick={handleShowModal} color={color}>
												{" "}
											</Close>
										</div>
									</div>

									<div className="product-data-sales"></div>
									<div className="product-data-subtitle">{product.title}</div>
									{product.references && product.references.length > 0 && (
										<div className="product-data-reference">
											{language[homeState.default_language]["ref"]}: {findAmountProduct("title")}
										</div>
									)}
									<div className="product-data-price">
										<div className="product-mainPrice">
											{findAmountProduct("discountRate") > 0 && (
												<div className="product-discountPrice">
													<CurrencyFormat
														amount={
															findAmountProduct("netAmount") !== 0
																? calculatePriceWithTax(findAmountProduct(null))
																: findAmountProduct("amount")
														}
													/>
												</div>
											)}
											<CurrencyFormat amount={findAmountProduct("amount")} />
										</div>
									</div>

									<div className="product-data-totalPrice">
										<div className="product-totalText">
											{language[homeState.default_language]["totalToPay"]}:
										</div>
										<div className="product-data-totalAmount">
											<CurrencyFormat
												amount={quantity * findAmountProduct("amount")}
											/>
										</div>
									</div>
								
									<div className="cart-data-buttons">
										<MainButton
											color={color}
											secondary={false}
											onClick={pushToSummary}
										>
											{language[homeState.default_language]["viewCart"]}
										</MainButton>
										<MainButton
											color={color}
											secondary={true}
											onClick={handleShowModal}
										>
											{language[homeState.default_language]["continueShopping"]}
										</MainButton>
									</div>
								</div>
							</div>
							{showModal && (
								<RelatedProducts
									isOnModal
								/>
							)}
						</>
					)}
				</section>
			</ResponsiveModal>
		</>
	);
};

export default MainModal;
